import { RootState, store } from 'ReduxStore/store';
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import AddDetails from 'Components/Details/AddDetails';
import Address from 'Components/Details/Address';
import Archived from 'Components/milestones/Archived';
import Calendar from 'Components/Calendar/Calendar';
import CalendarDetails from 'Components/Calendar/CalendarDetails';
import CalendarHome from 'Components/Calendar/CalendarHome';
import Categories from 'Components/Reusable/Categories/Categories';
import Checkouts from 'Components/Checkouts/Checkouts';
import Congratulations from 'Components/Congratulations/Congratulations';
import CustomMenu from 'Components/Reusable/Menu/CustomMenu';
import EmailActivated from 'Components/Congratulations/EmailActivated';
import EmailSent from 'Components/Congratulations/EmailSent';
import Footer from 'Components/Footer/Footer';
import ForgotPassword from 'Components/Authentication/Password/ForgotPassword';
import GenerateNewToy from 'Components/Timeline/GenerateNewToy';
import GiftCards from 'Components/GiftCards/GiftCard';
import Header from 'Components/Header/Header';
import HelloCard from 'Components/Reusable/Cards/ConditionalCard';
import Home from 'Components/Home/Home';
import ListAllExercises from 'Components/Exercises/ListAllExercises';
import ListAllResources from 'Components/resources/ListAllResources';
import ListExercise from 'Components/Exercises/ListExercise';
import ListMilestones from 'Components/milestones/ListMilestones';
import ListMilestonesCategory from 'Components/milestones/ListMilestonesCategory';
import Login from 'Components/Authentication/Login/Login';
import Membership from 'Components/Membership/Membership';
import MembershipCards from 'Components/Reusable/Cards/MembershipCards';
import MilestoneDetails from 'Components/milestones/MilestoneDetails';
import Milestones from 'Components/Upcoming/Milestones';
import NewPassword from 'Components/Authentication/Password/NewPassword';
import NewPayayment from 'Components/Payment/newP';
import NotFound from 'Components/NotFound/NotFound';
import Options from 'Components/Reusable/Options/Options';
import Payment from 'Components/Payment/Payment';
import Premium from 'Components/Payment/Premium';
import PrivateRoute from 'Components/Routes/PrivateRoute';
import Process from 'Components/Timeline/Timeline';
import React from 'react';
import ResetPassword from 'Components/Authentication/Password/ResetPassword';
import ResourceDetails from 'Components/resources/ResourceDetails';
import { Routes } from 'Utils/Route';
import Signup from 'Components/Authentication/Signup/Signup';
import Skills from 'Components/Reusable/Search/Skills';
import Upgrade from 'Components/Payment/Upgrade';
import Welcome from 'Components/Welcome/Welcome';
import YourDetails from 'Components/Details/YourDetails';
import { checkToken } from 'Helpers/auth';
import GiftCardActivated from 'Components/GiftCards/GiftCardActivated';
import PremiumCongratulations from 'Components/Congratulations/PremiumCongratuations';
import AdminLogin from 'Components/Authentication/Login/AdminLogin';
import AdminHomePage from 'Components/Admin/AdminHomePage';
import Boxes from 'Components/Admin/Boxes';

interface StateProps {
	isAuthenticated: boolean;
}

const AppRouter = () => {
	const isAuthenticated = useSelector((state: RootState) => state.users['isAuthenticated']);
	const user = useSelector((state: RootState) => state.users);

	const freeRoutes = [
		{ id: 1, path: Routes.Signup, exact: true, component: <Signup /> },
		{ id: 2, path: Routes.newPassword, exact: true, component: <NewPassword /> },
		{
			id: 3,
			path: Routes.Login,
			exact: true,
			component: <Login />,
		},
		{
			id: 4,
			path: Routes.forgotPassword,
			exact: true,
			component: <ForgotPassword />,
		},
		{
			id: 5,
			path: Routes.Home,
			exact: true,
			component: <Home />,
		},
		{
			id: 6,
			path: Routes.EmailSent,
			exact: true,
			component: <EmailSent />,
		},
		{
			id: 7,
			path: Routes.EmailActivated,
			exact: true,
			component: <EmailActivated />,
		},
		{
			id: 8,
			path: Routes.GiftMembership,
			exact: true,
			component: <GiftCards />,
		},
		{
			id: 9,
			path: Routes.GiftCardActivate,
			exact: true,
			component: <GiftCardActivated />,
		},
		{ id: 10, path: Routes.AdminLogin, exact: true, component: <AdminLogin /> },
	];

	// const unauthorizedRoutes = [
	// 	{
	// 		id: 6,
	// 		path: Routes.EmailSent,
	// 		exact: true,
	// 		component: <EmailSent />,
	// 	},
	// ];

	const unauthorizedRoutes = [
		{
			id: 2,
			path: Routes.Login,
			exact: true,
			component: <Login />,
		},
		{
			id: 3,
			path: Routes.Signup,
			exact: true,
			component: <Signup />,
		},
		{
			id: 4,
			path: Routes.Menu,
			exact: true,
			component: <CustomMenu />,
		},
		{
			id: 5,
			path: Routes.milestoneAchieved,
			exact: true,
			component: <Archived />,
		},
		{
			id: 6,
			path: Routes.YourDetails,
			exact: true,
			component: <YourDetails />,
		},
		{
			id: 7,
			path: Routes.RestPassword,
			exact: true,
			component: <ResetPassword />,
		},
		{
			id: 8,
			path: Routes.AddDetails,
			exact: true,
			component: <AddDetails />,
		},
		{
			id: 9,
			path: Routes.Congratulations,
			exact: true,
			component: <Congratulations />,
		},
		{
			id: 10,
			path: Routes.Membership,
			exact: true,
			component: <Membership />,
		},
		{
			id: 11,
			path: Routes.PaymentInformation,
			exact: true,
			component: <Payment />,
		},
		{
			id: 12,
			path: Routes.Categories,
			exact: true,
			component: <Categories />,
		},
		{
			id: 14,
			path: Routes.UpcomingMilestones,
			exact: true,
			component: <ListMilestones />,
		},
		{
			id: 15,
			path: Routes.Checkouts,
			exact: true,
			component: <Checkouts />,
		},
		{
			id: 16,
			path: Routes.ListAllExercises,
			exact: true,
			component: <ListAllExercises />,
		},
		{
			id: 17,
			path: Routes.ExerciseDetails,
			exact: true,
			component: <ListExercise />,
		},
		{
			id: 27,
			path: Routes.MilestoneCategories,
			exact: true,
			component: <ListMilestonesCategory />,
		},
		{
			id: 18,
			path: Routes.ListAllResources,
			exact: true,
			component: <ListAllResources />,
		},
		{
			id: 19,
			path: Routes.MilestoneListByCategories,
			exact: true,
			component: <ListMilestones />,
		},
		{
			id: 20,
			path: Routes.MilestoneDetails,
			exact: true,
			component: <MilestoneDetails />,
		},
		{
			id: 28,
			path: Routes.ResourceDetails,
			exact: true,
			component: <ResourceDetails />,
		},
		{
			id: 21,
			path: Routes.PremiumInformation,
			exact: true,
			component: <Premium />,
		},
		{
			id: 22,
			path: Routes.Process,
			exact: true,
			component: <Process />,
		},
		// {
		// 	id: 23,
		// 	path: Routes.Process,
		// 	exact: true,
		// 	component: <Process />,
		// },
		{
			id: 24,
			path: Routes.Calendar,
			exact: true,
			component: <Calendar />,
		},
		{
			id: 25,
			path: Routes.Skills,
			exact: true,
			component: <Skills />,
		},
		{
			id: 26,
			path: Routes.Options,
			exact: true,
			component: <Options />,
		},
		{ id: 27, path: Routes.Welcome, exact: true, component: <Welcome /> },
		{ id: 28, path: Routes.ListExerciseDetails, exact: true, component: <CalendarDetails /> },
		{ id: 29, path: Routes.generateNewToy, exact: true, component: <GenerateNewToy /> },
		{ id: 30, path: Routes.ExerciseHome, exact: true, component: <CalendarHome /> },
		{ id: 31, path: Routes.Address, exact: true, component: <Address /> },
		{ id: 32, path: Routes.Upgrade, exact: true, component: <Upgrade /> },
		{ id: 33, path: Routes.PremiumCongratulations, exact: true, component: <PremiumCongratulations /> },
		{ id: 34, path: Routes.AdminHome, exact: true, component: <AdminHomePage /> },
		{ id: 35, path: Routes.boxes, exact: true, component: <Boxes /> },
		{ id: 36, path: Routes.AdminLogin, exact: true, component: <AdminLogin /> },
	];

	const auth = checkToken();
	return (
		<Router>
			<Switch>
				{auth
					? unauthorizedRoutes.map(route => (
							<Route path={route.path} exact={route.exact} key={route.id}>
								{route.component}
							</Route>
					  ))
					: freeRoutes.map(route => (
							<Route path={route.path} exact={route.exact} key={route.id}>
								{route.component}
							</Route>
					  ))}
				<Route component={NotFound} />
			</Switch>
		</Router>
	);
};

export default AppRouter;
